import { defaultConfig } from './config.default';
import { vaTenantConfig } from './config.va';

const config = /*#__PURE__*/ (() => ({
  ...defaultConfig,
  larkPassportTemplateId: '6992782334254432259',
  region: 'jp',
  avatarDomain: 'https://project-jp.larksuite.com/goapi',
  host: 'https://project-jp.larksuite.com',
  hostForGo: 'https://project-jp.larksuite.com/goapi',
  collectHost: 'https://miigo-monitor.bytedance.com/inner',

  guideLink: 'https://bytedance.feishu.cn/docs/doccnhGBz5VDr5xFsGV9bGgcpwe',
  currentHost: 'https://project-jp.larksuite.com',
  tosBucket: 'meego-business-jp',
  larkLoginHost: 'https://www.larksuite.com',
  tenantConfig: vaTenantConfig,
  TeaConfig: {
    ...defaultConfig.TeaConfig,
    channel: 'va',
    app_id: 441507,
  },
  labProjectId: '620b229097e53d8b28d33e98',
  labViewId: 'bpcVAgB7RZ',
  showTenantIds: [],
  helpcenterUrl: 'https://project-jp.larksuite.com/helpcenter/home',
  internalApi: 'internal-api-lark-api.larksuite.com',
  passportApi: 'passport.larksuite.com',
}))();

export default config;
